import moment from 'moment-business-days';

export const roundNumber = (number) => {
    return parseFloat(number || 0).toFixed(2);
}

export const formatDate = (date, format = 'D.M.YYYY') => {
    return moment(date).format(format);
}

export const todayAndTomorrow = () => {
    const today = moment();
    const tomorrow = moment().add(1, 'days');
    return {today, tomorrow};
}

export const reduceArrayOfOptions = (array) => {
    return array?.reduce((accumulator, currentValue) => {
            if (accumulator.some(val => currentValue.id === val.id)) {
                return accumulator;
            }
            return [...accumulator, { id: currentValue.id, name: currentValue.name }];
    }, []);
}
